import { TextField } from "@mui/material";
import { FormikProps } from "formik";
import Flex from "@/components/Flex";
import { useFieldLock } from "@/components/ReadOnlyFields";
import { RosTemplate } from "@/services";
import HomeCareRosOptions from "./components/HomeCareRosOptions";
import HomeCareRosSafetyAssessment from "./components/HomeCareRosSafetyAssessment";
import HomeCareRosSystemRow from "./components/HomeCareRosSystemRow";
import { HOME_CARE_ROS_TABLE_SX } from "./home-care-ros-constant";
import {
  HOME_CARE_ROS_OPTIONS,
  HOME_CARE_ROS_SAFETY_ASSESSMENT,
} from "./home-care-ros-data";

export interface HomeCareRosFormProps {
  formik: FormikProps<RosTemplate>;
  disabled?: boolean;
}

const HomeCareRosForm = ({
  formik,
  disabled = false,
}: HomeCareRosFormProps) => {
  const lock = useFieldLock(disabled);
  const systems = formik.values?.rosTemplateTypeSet ?? [];
  const { handleBlur, handleChange, setFieldValue } = formik;

  const getFormikKey = (key: string, index: number) =>
    `rosTemplateTypeSet[${index}].${key}`;

  return (
    <Flex flexDirection="column" width="100%" sx={HOME_CARE_ROS_TABLE_SX}>
      {systems.map((system, index) => {
        if (!system.isSelected) return null;
        const options = system.name
          ? HOME_CARE_ROS_OPTIONS[system.name]
          : undefined;
        return (
          <HomeCareRosSystemRow key={system.name} name={system.name ?? ""}>
            {system.name === HOME_CARE_ROS_SAFETY_ASSESSMENT ? (
              <HomeCareRosSafetyAssessment
                value={system.value}
                disabled={lock.disabled}
                readOnly={lock.readOnly}
                onChange={(next) =>
                  setFieldValue(getFormikKey("value", index), next)
                }
              />
            ) : options ? (
              <HomeCareRosOptions
                catalog={options}
                value={system.value}
                disabled={lock.disabled}
                readOnly={lock.readOnly}
                onChange={(next) =>
                  setFieldValue(getFormikKey("value", index), next)
                }
              />
            ) : (
              <TextField
                disabled={lock.disabled}
                InputProps={{ readOnly: lock.readOnly }}
                fullWidth
                name={getFormikKey("value", index)}
                value={system.value}
                onChange={handleChange}
                onBlur={handleBlur}
                variant="outlined"
                size="small"
              />
            )}
          </HomeCareRosSystemRow>
        );
      })}
    </Flex>
  );
};

export default HomeCareRosForm;
